import React from "react";
import StaffSelfInfoPanel from "../../../settings/StaffSelfInfoPanel";

/* Thin wrapper — forwards to the shared StaffSelfInfoPanel used across the app.
   Renders as the "My Finances" tab in the staff workspace (fullBleed + hasFab):
   the panel owns its own hero and listens for the bottom-nav "+" FAB to open
   the loan-request modal via useBnavFab. */
export default function InfoPanel({state,dispatch,user,myStaffRecord,myLoans,activeLoanDeductions,netSalary,isRTL,lang,t}){
  return(
    <StaffSelfInfoPanel
      staffRecord={myStaffRecord} loanRequests={state.loanRequests||[]}
      activeLoanDeductions={activeLoanDeductions} netSalary={netSalary}
      myLoans={myLoans} dispatch={dispatch} users={state.users}
      staffAuthorities={state.staffAuthorities} isRTL={isRTL} lang={lang} t={t}
    />
  );
}
